{
  "id": "tomorrow-pm",
  "label": "Inför morgondagen",
  "sectionOrder": ["Inrikes", "Utrikes", "Ekonomi", "Kultur och nöje", "Sport"],
  "leadDays": 1,
  "planning": {
    "titlePattern": "TT:s pm för {dayName} den {dateRange}",
    "slugline": "TT-{dayName}-pm {fromDate}"
  },
  "preamble": ["Inför morgondagen vill vi tipsa om följande:"],
  "sources": [
    { "type": "planning", "newsvalues": ["3", "4", "5", "6"] },
    { "type": "event", "newsvalues": ["3", "4", "5", "6"] }
  ],
  "postamble": [
    "TT:s planeringar för text, grafik och bild/video kan även följas här: https://tt.se/planering/lista/, samt TT:s kalender: https://tt.se/kalender/lista/.",
    "Frågor om TT:s planering besvaras av tjänstgörande nyhetschef som nås på telefon 08-692 27 00. Redaktionen nås också via mejl: redaktionen@tt.se."
  ],
  "blocks": [
    {
      "id": "rest",
      "label": "Material",
      "preamble": [],
      "grouping": "section",
      "sectionHeadings": [
        { "section": "Inrikes", "heading": "Inrikes" },
        { "section": "Utrikes", "heading": "Utrikes" },
        { "section": "Ekonomi", "heading": "Ekonomi" },
        { "section": "Kultur och nöje", "heading": "Kultur och nöje" },
        { "section": "Sport", "heading": "Sport" }
      ],
      "otherSectionHeading": "Övrigt",
      "topNews": { "heading": "Toppnyheter", "types": ["planning"], "newsvalues": ["5", "6"] },
      "item": {
        "headline": "{headline}",
        "lines": ["{publicDescription}"],
        "assignmentLines": [
          { "types": ["text"], "pattern": "Text: {slugline}: {assignmentTitle}" },
          {
            "types": ["picture", "picture/video", "video"],
            "labels": {
              "picture": "Bild",
              "picture/video": "Bild/video",
              "video": "Video"
            },
            "pattern": "{assignmentLabel}: {assignmentTitle}"
          }
        ]
      },
      "eventItem": {
        "headline": "{time} - {headline} {publicDescription}",
        "lines": []
      },
      "eventTitleSections": ["Sport"],
      "eventsHeading": ["Presskonferenser och övrigt"]
    }
  ]
}
